import React from 'react';
import * as api from '../../../api'
// import { useNavigate } from 'react-router-dom';

const CompaniesList = (props) => {
    // const navigate = useNavigate();
    const [planning, setPlanning] = React.useState(null);

    React.useEffect(() => {
        if (!props.event) return;
        getPlanning()
    }, [props.event])
    function getPlanning(){
        api.GetPlanning({ eventId: props.event._id }).then((response) => {
            response.data.slots = response.data.slots.sort((a,b) => a.id - b.id)
            setPlanning(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    function displayName(part) {
        return part?.hsCompany?.properties?.name || part?.user?.email;
    }

    console.log(props)
    return (
        <div className='companies_cont'>
            Total Population A : {props.companies.length}
            {props.companies.sort((a,b) => displayName(a)?.localeCompare(displayName(b))).map((company,i) => 
                <div className='company' key={i} style={company.participation.data?.entreprise_validee ? {borderColor:"rgb(144, 221, 144)"}:{}}>
                    <a className='linkbutton title' key={i} href={"/evenements/editparticipation?eid=" + props.event._id + "&uid=" + company.user._id} target="_blank">{displayName(company)}</a>
                    {/* <b className='linkbutton title' onClick={()=>window.open("editprofile?eid="+props.event._id+"&poptype=a&email=" + company.user.email,"_blank","noreferrer")}>{displayName(company)}</b> */}
                    {company.participation.data?.entreprise_validee && <span className='green'>✓ </span>}
                    <div className='description'>
                        <span className='thin preformatted'>{company.participation.data?.description_admin_fr}</span>
                        <button className='admin_fields' onClick={()=>{props.setSelectedUser(company);props.setPannel("companyeditoradmin")}}>Champs administrateur</button><button className='admin_fields' style={{left:"250px"}} onClick={()=>{window.open("/profile?id=" + btoa(company.user.email),"_blank")}}>Voir le profil</button>
                        <button className='admin_fields' style={{left:"420px"}} onClick={()=>{window.open("/myprofile?id=" + btoa(company.user.email),"_blank")}}>Modifier le profil</button><button className='admin_fields' style={{left:"623px"}} onClick={()=>{window.open("/mycompany?id=" + btoa(company.user.email),"_blank")}}>Modifier la société</button><br/>
                    </div>
                    <span className='thin tooltip'>
                        {props.participants.filter(p => p.candidatures.find(c => c.participationId === company.participation._id)).length}
                        <span className="tooltiptext">Rendez-vous demandé(s)</span>
                    </span>
                    <span className='thin tooltip'>
                        {company.shortlist?.valide?.length || 0}
                        {/* {planning ? planning.data.filter(rdv => rdv.participationId === company.participation._id).length : 0} */}
                        <span className="tooltiptext">Candidatures validées dans la shortlist</span>
                    </span>
                    <span className='thin tooltip'>
                        {/* {props.participants.filter(p => p.candidatures.find(c => c.participationId === company.participation._id && c.)).length} */}
                        {planning ? planning.data.filter(rdv => rdv.participationId === company.participation._id).length : 0}
                        <span className="tooltiptext">Rendez-vous confirmé(s) dans le planning</span>
                    </span>
                    {/* <span style={{fontSize:"30px",color:"#0039d6"}} className='thin tooltip' onClick={()=>{props.setSelectedUser(company);props.setPannel("shortlisteditor")}}>
                    ···
                        <span style={{fontSize:"20px"}} className="tooltiptext">Accéder à la shortlist</span>
                    </span> */}
                    <span style={{fontSize:"30px",color:"#0039d6"}} className='thin tooltip' onClick={()=>{window.open("editshortlists?eid="+props.event._id+"&cid="+company.participation._id,"_blank","noreferrer")}}>
                    ···
                        <span style={{fontSize:"20px"}} className="tooltiptext">Accéder à la shortlist</span>
                    </span>
                </div>  
            )}
        </div>
    );
};

export default CompaniesList;